import { render, staticRenderFns } from "./ScrollStrip.vue?vue&type=template&id=cbaafaa4&scoped=true&"
import script from "./ScrollStrip.vue?vue&type=script&lang=js&"
export * from "./ScrollStrip.vue?vue&type=script&lang=js&"
import style0 from "./ScrollStrip.vue?vue&type=style&index=0&id=cbaafaa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbaafaa4",
  null
  
)

export default component.exports